/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Footer_QuickstartInputs */

const en_footer_quickstart = /** @type {(inputs: Footer_QuickstartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quickstart`)
};

const zh_hans1_footer_quickstart = /** @type {(inputs: Footer_QuickstartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`快速入门`)
};

const pt_br2_footer_quickstart = /** @type {(inputs: Footer_QuickstartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Início rápido`)
};

const es_footer_quickstart = /** @type {(inputs: Footer_QuickstartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inicio rápido`)
};

const fr_footer_quickstart = /** @type {(inputs: Footer_QuickstartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrage rapide`)
};

const de_footer_quickstart = /** @type {(inputs: Footer_QuickstartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schnellstart`)
};

const ru_footer_quickstart = /** @type {(inputs: Footer_QuickstartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Быстрый старт`)
};

const it_footer_quickstart = /** @type {(inputs: Footer_QuickstartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guida rapida`)
};

/**
* | output |
* | --- |
* | "Quickstart" |
*
* @param {Footer_QuickstartInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const footer_quickstart = /** @type {((inputs?: Footer_QuickstartInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Footer_QuickstartInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_footer_quickstart(inputs)
	if (locale === "pt-BR") return pt_br2_footer_quickstart(inputs)
	if (locale === "es") return es_footer_quickstart(inputs)
	if (locale === "fr") return fr_footer_quickstart(inputs)
	if (locale === "de") return de_footer_quickstart(inputs)
	if (locale === "ru") return ru_footer_quickstart(inputs)
	if (locale === "it") return it_footer_quickstart(inputs)
	return en_footer_quickstart(inputs)
});